import config from '../../config';
import { getAccessTokenClient, getApiKeyClient } from '../client/http';

const {
  apiBaseUrl: { queues: baseUrl },
} = config;

const accessTokenClient = () => getAccessTokenClient(baseUrl);
const apiKeyClient = () => getApiKeyClient(baseUrl);

export const queuesDelete = async (elementId: string, isPublic?: boolean) => {
  try {
    await (isPublic ? apiKeyClient : accessTokenClient)().delete(
      `api/queues/${elementId}`,
    );
  } catch (err: any) {
    throw new Error(`Error deleting queues: ${err.message}`);
  }
};
